/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import type { PositionLib, PositionLibInterface } from '../PositionLib'

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'subVaultId',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'asset0',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'asset1',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debt0',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debt1',
            type: 'uint256'
          },
          {
            components: [
              {
                internalType: 'bool',
                name: 'isCollateral',
                type: 'bool'
              },
              {
                internalType: 'uint128',
                name: 'liquidity',
                type: 'uint128'
              },
              {
                internalType: 'int24',
                name: 'lowerTick',
                type: 'int24'
              },
              {
                internalType: 'int24',
                name: 'upperTick',
                type: 'int24'
              }
            ],
            internalType: 'struct DataType.LPT[]',
            name: 'lpts',
            type: 'tuple[]'
          }
        ],
        internalType: 'struct DataType.Position[]',
        name: '_positions',
        type: 'tuple[]'
      },
      {
        internalType: 'bool',
        name: '_isQuoteZero',
        type: 'bool'
      },
      {
        internalType: 'uint160',
        name: '_sqrtPrice',
        type: 'uint160'
      },
      {
        internalType: 'uint256',
        name: '_swapRatio',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_closeRatio',
        type: 'uint256'
      }
    ],
    name: 'getPositionUpdatesToClose',
    outputs: [
      {
        components: [
          {
            internalType: 'enum DataType.PositionUpdateType',
            name: 'positionUpdateType',
            type: 'DataType.PositionUpdateType'
          },
          {
            internalType: 'uint256',
            name: 'subVaultId',
            type: 'uint256'
          },
          {
            internalType: 'bool',
            name: 'zeroForOne',
            type: 'bool'
          },
          {
            internalType: 'uint128',
            name: 'liquidity',
            type: 'uint128'
          },
          {
            internalType: 'int24',
            name: 'lowerTick',
            type: 'int24'
          },
          {
            internalType: 'int24',
            name: 'upperTick',
            type: 'int24'
          },
          {
            internalType: 'uint256',
            name: 'param0',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'param1',
            type: 'uint256'
          }
        ],
        internalType: 'struct DataType.PositionUpdate[]',
        name: 'positionUpdates',
        type: 'tuple[]'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'subVaultId',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'asset0',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'asset1',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debt0',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debt1',
            type: 'uint256'
          },
          {
            components: [
              {
                internalType: 'bool',
                name: 'isCollateral',
                type: 'bool'
              },
              {
                internalType: 'uint128',
                name: 'liquidity',
                type: 'uint128'
              },
              {
                internalType: 'int24',
                name: 'lowerTick',
                type: 'int24'
              },
              {
                internalType: 'int24',
                name: 'upperTick',
                type: 'int24'
              }
            ],
            internalType: 'struct DataType.LPT[]',
            name: 'lpts',
            type: 'tuple[]'
          }
        ],
        internalType: 'struct DataType.Position',
        name: '_position',
        type: 'tuple'
      },
      {
        internalType: 'bool',
        name: '_isQuoteZero',
        type: 'bool'
      },
      {
        internalType: 'uint160',
        name: '_sqrtPrice',
        type: 'uint160'
      },
      {
        internalType: 'uint256',
        name: '_swapRatio',
        type: 'uint256'
      }
    ],
    name: 'getPositionUpdatesToOpen',
    outputs: [
      {
        components: [
          {
            internalType: 'enum DataType.PositionUpdateType',
            name: 'positionUpdateType',
            type: 'DataType.PositionUpdateType'
          },
          {
            internalType: 'uint256',
            name: 'subVaultId',
            type: 'uint256'
          },
          {
            internalType: 'bool',
            name: 'zeroForOne',
            type: 'bool'
          },
          {
            internalType: 'uint128',
            name: 'liquidity',
            type: 'uint128'
          },
          {
            internalType: 'int24',
            name: 'lowerTick',
            type: 'int24'
          },
          {
            internalType: 'int24',
            name: 'upperTick',
            type: 'int24'
          },
          {
            internalType: 'uint256',
            name: 'param0',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'param1',
            type: 'uint256'
          }
        ],
        internalType: 'struct DataType.PositionUpdate[]',
        name: 'positionUpdates',
        type: 'tuple[]'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  }
]

const _bytecode =
  '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'

export class PositionLib__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0])
    } else {
      super(...args)
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PositionLib> {
    return super.deploy(overrides || {}) as Promise<PositionLib>
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {})
  }
  attach(address: string): PositionLib {
    return super.attach(address) as PositionLib
  }
  connect(signer: Signer): PositionLib__factory {
    return super.connect(signer) as PositionLib__factory
  }
  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): PositionLibInterface {
    return new utils.Interface(_abi) as PositionLibInterface
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PositionLib {
    return new Contract(address, _abi, signerOrProvider) as PositionLib
  }
}
